<template>
  <v-card max-width="100%" width="100%">
    <v-toolbar dense color="primary" dark>
      <v-spacer></v-spacer>
      <v-toolbar-title>{{$t('stats.cost')}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="secondary" @click="changeType">{{type === "area" ? 'Bar' : 'Line'}}</v-btn>
    </v-toolbar>
    <v-card-text>
      <v-col v-if="!chart" cols="12" align="center" style="height: 400px">
          <v-progress-circular
          style="margin-top: 150px"
            :size="100"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-col>
      <div id="chartKPI"></div>
    </v-card-text>
  </v-card>
</template>
<script>
import ApexCharts from "apexcharts";
export default {
  name: "Cost",
  data() {
    return {
      type: "bar",
      chart: null
    };
  },
  mounted() {
    setTimeout(() => this.render(), 0)
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  },
  methods: {
    async render() {
      let categories = this.categories()
      let series = this.series()
      let options = {
        colors:['#008ffb', '#E91E63'],
        series: series,
        xaxis: {
          categories: categories
        },
        chart: {
          type: this.type,
          stacked: true,
          height: 400
        }
      }
      if (this.chart) {
        this.chart.updateOptions(options, true);
      } else {
        this.chart = new ApexCharts(document.querySelector("#chartKPI"), options);
        this.chart.render();
      }
    },
    categories() {
      let categories = [];
      for (let index = 0; index < this.$store.getters['company/data'].cost.remains.length; index++) {
       categories.push(this.$t('general.smallWeek') + (index + 1))
    }
      return categories;
    },
    series() {
      let series = [];
      series.push({
        name: this.$t('stats.stock'),
        data: this.$store.getters['company/data'].cost.stock
      })
      series.push({
        name: this.$t('stats.remains'),
        data: this.$store.getters['company/data'].cost.remains
      })
      return series;
    },
    async changeType () {
      if (this.type == 'area') {
        this.type = 'bar'
      } else {
        this.type = 'area'
      }
      this.render()
    }
  }
};
</script>
